import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useMemo } from 'react';
import { components } from 'react-select';
import Link from '../../../typography/Link';
import Icon from '../../../general/Icon';
import Text from '../../../typography/Text';
import { useTheme } from '../../../../utils/styles';
export default /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var _props$selectProps$me = props.selectProps.menuProps,
    className = _props$selectProps$me.className,
    actionContainerClassName = _props$selectProps$me.actionContainerClassName,
    actionClassName = _props$selectProps$me.actionClassName,
    actionIconClassName = _props$selectProps$me.actionIconClassName,
    actionTextClassName = _props$selectProps$me.actionTextClassName,
    actionTextWithIconClassName = _props$selectProps$me.actionTextWithIconClassName,
    override = _props$selectProps$me.override,
    actions = _props$selectProps$me.actions,
    onClickAction = _props$selectProps$me.onClickAction,
    dropdownWidth = _props$selectProps$me.dropdownWidth;
  var linkRow = useCallback(function (action, index) {
    if (action.component) {
      var onClick = action.onClick ? function () {
        onClickAction && onClickAction(action);
        action.onClick && action.onClick();
      } : null;
      return /*#__PURE__*/React.createElement("div", _extends({
        key: index,
        className: actionClassName
      }, override.action, {
        onClick: onClick
      }), action.component);
    }
    var icon = action.icon;
    var iconType = action.iconType;
    var finalIcon;
    if (icon) finalIcon = icon;else if (iconType) finalIcon = /*#__PURE__*/React.createElement(Icon, {
      name: iconType,
      color: theme.colors.orange500
    });
    var textClasses = [actionTextClassName];
    var textOverride = _objectSpread({}, override.actionText);
    if (finalIcon) {
      textClasses = [actionTextWithIconClassName];
      textOverride = _objectSpread(_objectSpread({}, textOverride), override.actionTextWithIcon);
    }
    return /*#__PURE__*/React.createElement("div", _extends({
      className: actionClassName,
      key: index
    }, override.action, {
      onClick: function onClick() {
        onClickAction && onClickAction(action);
        action.onClick && action.onClick();
      }
    }), finalIcon && /*#__PURE__*/React.createElement("div", _extends({
      className: actionIconClassName
    }, override.actionIcon), finalIcon ? finalIcon : null), /*#__PURE__*/React.createElement("div", _extends({
      className: textClasses
    }, textOverride), action.isLink && /*#__PURE__*/React.createElement(Link, null, action.label), !action.isLink && /*#__PURE__*/React.createElement(Text, {
      color: "orange500",
      type: "subtitle"
    }, action.label)));
  }, [theme.colors.orange500, actionTextClassName, override.actionText, override.action, override.actionIcon, override.actionTextWithIcon, actionClassName, actionIconClassName, actionTextWithIconClassName, onClickAction]);
  var innerProps = useMemo(function () {
    if (dropdownWidth) return _objectSpread(_objectSpread({}, props.innerProps), {}, {
      style: {
        width: dropdownWidth
      }
    });
    return props.innerProps;
  }, [dropdownWidth, props]);
  return components.Menu && /*#__PURE__*/React.createElement(components.Menu, _extends({}, props, {
    className: className,
    innerProps: innerProps
  }, override.menu), children, actions && /*#__PURE__*/React.createElement("div", _extends({
    className: actionContainerClassName
  }, override.actionContainer), actions.map(function (action, idx) {
    return linkRow(action, idx);
  })));
});